import { Button, Dialog, IconButton, Text, Tooltip } from '@radix-ui/themes';
import { UserMinus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const RemoveUserAccessGroup = ({
  accessGroup,
  user,
  loading,
  onSubmit,
  disable = false,
  disabledReason,
}: {
  accessGroup: { id: string; name: string };
  user: { id: string; firstName: string; lastName: string };
  loading: boolean;
  onSubmit: (agId: string, userId: string) => Promise<void>;
  disable: boolean;
  disabledReason?: string;
}) => {
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit(accessGroup.id, user.id).then(() => {});
  };

  return (
    <Dialog.Root>
      <Tooltip
        content={
          <Text size="3">{disabledReason ?? t('settings.accessGroupDialogs.removeUserAccessGroup.tooltip')}</Text>
        }
      >
        <Dialog.Trigger>
          <IconButton variant="ghost" color="gray" highContrast className="m-0" disabled={disable || !!disabledReason}>
            <UserMinus size={20} />
          </IconButton>
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content>
        <Dialog.Title>{t('settings.accessGroupDialogs.removeUserAccessGroup.dialogTitle')}</Dialog.Title>
        <Dialog.Description>
          {t('settings.accessGroupDialogs.removeUserAccessGroup.description', {
            userName: `${user.firstName} ${user.lastName}`,
            groupName: accessGroup.name,
          })}
        </Dialog.Description>

        <div className="flex flex-row justify-between w-full pt-4">
          <Dialog.Close>
            <Button size="3" color="gray" variant="soft" className="w-full">
              {t('settings.accessGroupDialogs.removeUserAccessGroup.cancelButton')}
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button size="3" color="amber" className="w-full" loading={loading} onClick={handleSubmit}>
              {t('settings.accessGroupDialogs.removeUserAccessGroup.removeButton')}
            </Button>
          </Dialog.Close>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default RemoveUserAccessGroup;
